const GET_MARKET_DROP_DOWN_LIST = 'GET_MARKET_DROP_DOWN_LIST';
const SET_MARKET_DROP_DOWN_LIST = 'SET_MARKET_DROP_DOWN_LIST';

export {
    GET_MARKET_DROP_DOWN_LIST,
    SET_MARKET_DROP_DOWN_LIST
};